exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-top-cust[data-v-45881fe7]{position:-webkit-sticky;position:sticky;top:120px!important;z-index:98}", ""]);

// exports
